var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncomingCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#D0F3C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9636 6.5C14.8112 6.72796 15.5841 7.17464 16.2047 7.79529C16.8254 8.41595 17.272 9.18879 17.5 10.0364",
    stroke: "#02A57D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4458 8.43237C13.9544 8.56915 14.4181 8.83716 14.7905 9.20955C15.1629 9.58194 15.4309 10.0457 15.5677 10.5542",
    stroke: "#02A57D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77977 11.801C10.2984 12.8614 11.1579 13.7169 12.2206 14.2308C12.2984 14.2676 12.3844 14.2836 12.4702 14.2771C12.5559 14.2706 12.6386 14.2419 12.7099 14.1937L14.2746 13.1503C14.3438 13.1042 14.4235 13.076 14.5063 13.0684C14.5891 13.0608 14.6725 13.074 14.749 13.1068L17.6763 14.3613C17.7757 14.4036 17.8588 14.477 17.9128 14.5705C17.9669 14.664 17.9892 14.7726 17.9762 14.8799C17.8837 15.6039 17.5304 16.2693 16.9826 16.7516C16.4347 17.2339 15.7299 17.5 15 17.5001C12.7457 17.5001 10.5837 16.6045 8.98959 15.0105C7.39553 13.4164 6.5 11.2544 6.5 9.00006C6.50004 8.27017 6.76612 7.56532 7.24843 7.01748C7.73073 6.46965 8.39618 6.1164 9.12019 6.02387C9.22745 6.01089 9.33602 6.03312 9.42955 6.08721C9.52307 6.1413 9.59649 6.22432 9.63873 6.32376L10.8944 9.25363C10.9269 9.32941 10.9401 9.41205 10.9329 9.49419C10.9257 9.57632 10.8983 9.65541 10.8532 9.7244L9.81341 11.3131C9.76608 11.3846 9.7381 11.4671 9.73221 11.5526C9.72631 11.6381 9.7427 11.7237 9.77977 11.801V11.801Z",
    stroke: "#02A57D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingCall);
export default __webpack_public_path__ + "static/media/incoming-call.eba43bef859e64f6662a9adcc5bb6847.svg";
export { ForwardRef as ReactComponent };